<template>
<div style="padding: 10px">

    <!--    搜索区域-->
    <el-form :inline="true">
        <el-form-item label="对应日期">
            <el-date-picker v-model="curDate" type="date" placeholder="选择日期" value-format="YYYY-MM-DD" format="YYYY-MM-DD">
            </el-date-picker>
        </el-form-item>

        <el-form-item label="房间名称">
            <el-select v-model="gameId" placeholder="请选择">
                <el-option v-for="item in gameList" :key="item.code" :label="item.name" :value="item.code">
                    <span style="float: left">{{ item.name }}</span>
                </el-option>
            </el-select>

        </el-form-item>
        <el-form-item label="预约情况">
            <el-select v-model="leaveNm" placeholder="请选择">
                <el-option v-for="item in leaveNmList" :key="item.code" :label="item.name" :value="item.code">
                    <span style="float: left">{{ item.name }}</span>
                </el-option>
            </el-select>

        </el-form-item>
        <el-button type="primary" style="margin-left: 5px" @click="load">查询</el-button>
        <el-button type="primary" @click="add">新增</el-button>
        <!-- <el-upload action="http://localhost:9090/gameTime/import" :on-success="handleUploadSuccess" :show-file-list=false :limit="1" accept='.xlsx' style="display: inline-block; margin: 0 10px">
            <el-button type="primary">导入</el-button>
        </el-upload>
        <el-button type="primary" @click="exportgameTime">导出</el-button> -->
    </el-form>

    <el-table v-loading="loading" :data="tableData" border stripe style="width: 100%">
        <el-table-column align="center" label="序号" type="index" width="90"></el-table-column>
        <el-table-column prop="gameId" label="房间名称" align="center" :formatter="formatterGame">
        </el-table-column>
        <el-table-column prop="name" label="时间点" align="center">
        </el-table-column>

        <el-table-column prop="curDate" label="对应日期" align="center">
        </el-table-column>
        
        <el-table-column prop="leaveNm" label="剩余数量" align="center">
        </el-table-column>

        <el-table-column prop="leaveNm" label="预约情况" align="center">
            <template #default="scope">
                <el-tag type="success" v-if="scope.row.leaveNm!='0'">可预约</el-tag>               
                <el-tag type="danger" v-if="scope.row.leaveNm=='0'">已预约</el-tag>
            </template>
        </el-table-column>

        <el-table-column label="操作" width="150" align="center">
            <template #default="scope">
                <el-button size="mini" type="primary" plain @click="handleEdit(scope.row)">编辑</el-button>
                <el-popconfirm title="确定删除吗？" @confirm="handleDelete(scope.row.id)">
                    <template #reference>
                        <el-button size="mini" type="danger">删除</el-button>
                    </template>
                </el-popconfirm>
            </template>
        </el-table-column>
    </el-table>

    <div style="margin: 10px 0">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[5, 10, 20]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
    </div>
    <el-dialog title="提示" v-model="dialogVisible" width="30%">
        <el-form :model="form" label-width="120px">

            <el-form-item label="时间点">

                <el-select v-model="form.name" placeholder="请选择">
                    <el-option v-for="item in timeList" :key="item.code" :label="item.name" :value="item.name">
                        <span style="float: left">{{ item.name }}</span>
                    </el-option>
                </el-select>

            </el-form-item>

            <el-form-item label="房间">

                <el-select v-model="form.gameId" placeholder="请选择">
                    <el-option v-for="item in gameList" :key="item.code" :label="item.name" :value="item.code">
                        <span style="float: left">{{ item.name }}</span>
                    </el-option>
                </el-select>

            </el-form-item>

            <el-form-item label="对应日期">

                <el-date-picker v-model="form.curDate" type="date" placeholder="选择日期" format="YYYY-MM-DD">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="剩余数量">
                <el-input v-model="form.leaveNm" style="width: 80%"></el-input>
            </el-form-item>

        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </span>
        </template>
    </el-dialog>

</div>
</template>

<script>
import request from "@/utils/request";
import axios from 'axios'
export default {
    name: 'GameTime',
    components: {},
    data() {
        return {
            loading: true,
            form: {},
            leaveNmList:[
                {code:'0', name:'已预约'},
                {code:'1', name:'可预约'}
            ],
            curDate: '',
            leaveNm:'',
            gameId: '',
            dialogVisible: false,
            bookVis: false,
            name: '',
            currentPage: 1,
            pageSize: 10,
            total: 0,
            tableData: [],
            gameList: [],
            timeList: [],
        }
    },
    created() {
        this.initPage()
    },
    methods: {
        initPage() {
            axios.all([
                // 列表初始化
                request.get("/popular/all", {}),
                request.get("/gameTime", {
                    pageNum: this.currentPage,
                    pageSize: this.pageSize,
                    curDate: this.curDate,
                    gameId: this.gameId,
                    name: this.name
                }), request.get("/time/all", {}),
            ]).then(axios.spread((res1, res2, res3) => {
                this.loading = false
                this.tableData = res2.data.records
                this.total = res2.data.total
                this.gameList = res1.data
                this.timeList = res3.data

            }))
        },
        handleChange(row) {
            request.put("/gameTime/changeRole", row).then(res => {
                if (res.code === 200) {
                    this.$message.success("更新成功")
                    if (res.data) {
                        this.$router.push("/login")
                    }
                }
            })
        },
        formatterGame(row, column) {
            var realValue = ''
            this.gameList.forEach(function (item, index) {

                if (row.gameId == item.code) {
                    realValue = item.name
                    return
                }
            })

            return realValue;

        },
        showBooks(books) {
            this.bookList = books
            this.bookVis = true
        },
        formatDate(row, column) {
            let data = row[column.property];
            if (data == null) {
                return null;
            }
            let dt = new Date(data)
            return dt.getFullYear() + '年' + (dt.getMonth() + 1) + '月' + dt.getDate() + '日 ' + dt.getHours() + ':' + dt.getMinutes() + ':' + dt.getSeconds()
        },
        load() {
            this.loading = true
            request.get("/gameTime", {
                params: {
                    pageNum: this.currentPage,
                    pageSize: this.pageSize,
                    curDate: this.curDate,
                    gameId: this.gameId,
                    name: this.name,
                    leaveNm:this.leaveNm
                }
            }).then(res => {
                this.loading = false
                this.tableData = res.data.records
                this.total = res.data.total
            })

            request.get("/role/all").then(res => {
                this.roles = res.data
            })
        },
        handleUploadSuccess(res) {
            if (res.code === "0") {
                this.$message.success("导入成功")
                this.load()
            }
        },
        exportgameTime() {
            location.href = "http://" + window.server.filesUploadUrl + ":9090/gameTime/export";
        },
        add() {
            this.dialogVisible = true
            this.form = {}
        },
        save() {
            if (this.form.id) { // 更新
                request.put("/gameTime", this.form).then(res => {
                    console.log(res)
                    if (res.code === 200) {
                        this.$message({
                            type: "success",
                            message: "更新成功"
                        })
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg
                        })
                    }
                    this.load() // 刷新表格的数据
                    this.dialogVisible = false // 关闭弹窗
                })
            } else { // 新增
                request.post("/gameTime", this.form).then(res => {
                    console.log(res)
                    if (res.code === 200) {
                        this.$message({
                            type: "success",
                            message: "新增成功"
                        })
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg
                        })
                    }

                    this.load() // 刷新表格的数据
                    this.dialogVisible = false // 关闭弹窗
                })
            }

        },
        handleEdit(row) {
            this.form = JSON.parse(JSON.stringify(row))
            this.dialogVisible = true
        },
        handleDelete(id) {
            console.log(id)
            request.delete("/gameTime/" + id).then(res => {
                if (res.code === 200) {
                    this.$message({
                        type: "success",
                        message: "删除成功"
                    })
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg
                    })
                }
                this.load() // 删除之后重新加载表格的数据
            })
        },
        handleSizeChange(pageSize) { // 改变当前每页的个数触发
            this.pageSize = pageSize
            this.load()
        },
        handleCurrentChange(pageNum) { // 改变当前页码触发
            this.currentPage = pageNum
            this.load()
        }
    }
}
</script>
